/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Coming_SoonInputs */

const cs_portals_coming_soon = /** @type {(inputs: Portals_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravujeme`)
};

const en_portals_coming_soon = /** @type {(inputs: Portals_Coming_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Portals_Coming_SoonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_coming_soon = /** @type {((inputs?: Portals_Coming_SoonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Coming_SoonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_coming_soon(inputs)
	return cs_portals_coming_soon(inputs)
});